#hidden-modal-close-icon {
  display: none;
}

.modal-close-button {
  color: var(--rds-foreground-primary);
}
.modal-close-button svg {
  fill: currentColor;
}
.modal-close-button:focus {
  outline: 1px solid var(--focus-color);
}

.modal {
  padding: 0;
  background: transparent;
  max-width: 80vw;
}

.overlay {
  background-color: rgba(0, 0, 0, 0.9);
}

.full-width-modal {
  width: 100%;
  height: 100%;
  margin: 0;
  max-width: none;
}

.center {
  display: grid;
  place-items: center;
}
